function truncFloat(value, decimals) {
  return Number(Math.trunc(Number(value + 'e' + decimals)) + 'e-' + decimals);
}
export var squareParser = function squareParser(value, maxSquareValue, squareDigitFraction) {
  var num = Number(value);
  if (isNaN(num)) {
    return 0;
  }
  if (num > maxSquareValue) {
    return maxSquareValue;
  }
  return truncFloat(num, squareDigitFraction);
};
export var parseNumber = function parseNumber(number) {
  if (typeof number === 'string') {
    return parseFloat(number.replace(/[^\d.]/g, ''));
  }
  return parseFloat(number);
};
export var parseNumberOrUndefined = function parseNumberOrUndefined(number) {
  var num = parseNumber(number);
  if (isNaN(num)) {
    return;
  }
  return num;
};